import React, { type ComponentProps } from 'react';
import { cssMap } from '@compiled/react';
import { Box } from '@atlaskit/primitives/compiled';
import { lazyForPaint, LazySuspense } from 'react-loosely-lazy';
import { I18nProvider, PerformanceMetricsProvider } from '@atlassian/embedded-confluence-common';
import fetchTranslations from '../i18n/fetchTranslations';

const styles = cssMap({
	fallback: {
		width: '100%',
		height: '100%',
	},
});

const LazyPage = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_embedded-confluence-page" */
			'./Page'
		),
);

export type PageProps = ComponentProps<typeof LazyPage> & { locale?: string };

// Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
// They will not function correctly due to a lack of I18n context.

export const Page = (props: PageProps) => (
	<I18nProvider locale={props.locale} fetchTranslations={fetchTranslations}>
		<PerformanceMetricsProvider>
			<LazySuspense fallback={<Box xcss={styles.fallback}></Box>}>
				<LazyPage {...props} />
			</LazySuspense>
		</PerformanceMetricsProvider>
	</I18nProvider>
);
